import { useQuery } from '@tanstack/react-query';
import { apiService } from '../services/api';

// STD-015: server state for access-check probes. apiService is imported here
// (a *.queries.ts file) per STD-016. Both queries opt out of the global error
// toast because access probes are silent — a 403 / network error simply means
// hasAccess:false for the caller, consistent with the previous hook behaviour.

export const accessKeys = {
  analyticsAccess: () => ['access', 'analytics'] as const,
  agentsAccess: () => ['access', 'agents'] as const,
};

export function useAnalyticsAccessQuery() {
  return useQuery({
    queryKey: accessKeys.analyticsAccess(),
    meta: { skipGlobalErrorToast: true },
    queryFn: async () => (await apiService.checkAnalyticsAccess()).has_access,
  });
}

export function useAgentsAccessQuery() {
  return useQuery({
    queryKey: accessKeys.agentsAccess(),
    meta: { skipGlobalErrorToast: true },
    queryFn: async () => (await apiService.checkAgentsAccess()).has_access,
  });
}
